import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=51ae6fb6&scoped=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=ts"
export * from "./ForgottenPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=51ae6fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae6fb6",
  null
  
)

export default component.exports